import React from "react";
import { BsPhoneVibrateFill } from "react-icons/bs";
import { FaMapMarkedAlt } from "react-icons/fa";
import { TfiEmail } from "react-icons/tfi";
import UseTitle from "../../Hooks/UseTitle";

const Contact = () => {
  UseTitle("Contact Us");
  return (
    <div className="bg-slate-100 bg-contact">
      <div className="max-w-screen-xl mx-auto py-32  px-5 md:px-20">
        <div className="grid md:grid-cols-3 grid-cols-1 gap-10 cursor-pointer">
          <div className="group hover:shadow-2xl hover:-translate-y-6 duration-300 bg-white text-center  md:text-[20px]  text-[18px] flex justify-center flex-col shadow-lg p-6">
            <div>
              <BsPhoneVibrateFill className="inline-block md:text-[50px] text-[30px] text-[#bb4f32]  mb-5" />
            </div>
            <p>
              <span>Contact Number:</span>
            </p>
            <p className="group-hover:text-[#bb4f32]">
              <a href="tel:01867-877677">01867 877 677</a>
            </p>
          </div>
          <div className="bg-gray-700 hover:shadow-2xl hover:-translate-y-6 duration-300 text-white text-center md:text-[20px] text-[18px] flex justify-center flex-col shadow-lg p-6">
            <div>
              <FaMapMarkedAlt className="inline-block md:text-[50px] text-[30px] text-[#bb4f32] mb-5" />
            </div>
            <p>
              <span>Address:</span>
            </p>
            <p>
              Uttar-Pelayed, Murgi Bazar - Saitaliya Road, Telihaty,
              Gazipur-1740, Bangladesh
            </p>
          </div>
          <div className="group bg-white hover:-translate-y-6 duration-300 py-5 hover:shadow-2xl text-center  flex justify-center flex-col shadow-lg ">
            <div>
              <TfiEmail className="inline-block md:text-[50px] text-[30px] text-[#bb4f32] mb-5" />
            </div>
            <p>
              <span>Email:</span>
            </p>
            <p className="group-hover:text-[#bb4f32]">
              <a href="mailto: booking.matirmayaecoresort@gmail.com">
                booking.matirmayaecoresort@gmail.com
              </a>
            </p>
          </div>
        </div>
        <div className="my-10 shadow-xl hover:shadow-2xl p-2 bg-white">
          <iframe
            height="400"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d69199.5798858939!2d90.50020682873833!3d24.281797538988993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3756717c98da359b%3A0x7b4d67a1e965542c!2sMatir%20Maya%20Eco%20Resort%2C%20Sreepur%2C%20Gazipur!5e0!3m2!1sen!2sbd!4v1678089584960!5m2!1sen!2sbd"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            title="matir maya map"
            className="w-full"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
